/*
 * @Author: ningbo.kang
 * @Date: 2019-10-09 10:22:16
 * @LastEditors: zerui.yao
 * @LastEditTime: 2023-12-25 14:12:18
 * @FilePath: /fed-authority/src/utils/index.js
 * @Description: 描述
 */
import log from './util.log';
import {
  toTreeData as aliasToTreeData,
  getTopData as aliasGetTopData,
  toSelectTreeData as aliasToSelectTreeData,
} from './util.tree';
import { mergeColumns as aliasMergeColumns, fixedColumns as aliasFixedColumns } from './util.table';

const util = {
  log,
};

/**
 * @description 更新标题
 * @param {String} title 标题
 */
util.title = (titleText) => {
  const processTitle = process.env.VUE_APP_NAME;
  window.document.title = `${processTitle}${titleText ? ` | ${titleText}` : ''}`;
};

/**
 * @description 打开新页面
 * @param {String} url 地址
 */
util.open = (url) => {
  const a = document.createElement('a');
  a.setAttribute('href', url);
  a.setAttribute('target', '_blank');
  a.setAttribute('id', 'e2admin-link-temp');
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(document.getElementById('e2admin-link-temp'));
};

export default util;

/**
 * @description: 将具有节点和父节点的数组，转换为树状节点
 * @param {Array} dataSource 数组数据，带有节点和父节点
 * @return: 树状数组
 */
export const toTreeData = aliasToTreeData;
export const getTopData = aliasGetTopData;
export const toSelectTreeData = aliasToSelectTreeData;

// 表格自定义列与数据库配置列合并,返回合并后列数组
export const mergeColumns = aliasMergeColumns;
// 表格自定义列与数据库配置列合并,返回{columns:合并后列数组, maxWidth:最大宽度合计}
export const fixedColumns = aliasFixedColumns;
/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent() {
  const event = document.createEvent('HTMLEvents');
  event.initEvent('resize', true, true);
  event.eventType = 'message';
  window.dispatchEvent(event);
}

export function goSSO() {
  window.location.replace(
    `${process.env.VUE_APP_API_SSO_URL}/#/login?client=${
      process.env.VUE_APP_CLIENT_ID
    }&target=${encodeURIComponent(window.location.href)}`
  );
}

export function paramTrim(obj) {
  const objBak = obj;
  for (const i in objBak) {
    if (objBak[i] === '') delete objBak[i];
  }
  return objBak;
}
